import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem as MuiListItem, } from '@mui/material';
import { styled } from '../../utils';
export var ListStyleType;
(function (ListStyleType) {
    // you can add more types here if u need it
    ListStyleType["DISC"] = "disc";
})(ListStyleType || (ListStyleType = {}));
export function ListItem({ noMargin, liststyle, color, typographyVariant, ...props }) {
    return (_jsx(ListItemStyled, { noMargin: noMargin, liststyle: liststyle, color: color, typographyVariant: typographyVariant, ...props }));
}
const ListItemStyled = styled(MuiListItem, {
    shouldForwardProp: (prop) => prop !== 'noMargin' &&
        prop !== 'liststyle' &&
        prop !== 'color' &&
        prop !== 'typographyVariant',
})(({ theme, noMargin, liststyle, color, typographyVariant }) => ({
    padding: theme.spacing(1, 1.5),
    margin: noMargin ? theme.spacing(0) : theme.spacing(1, 0),
    color: color ?? theme.palette.secondary.dark,
    ...((typographyVariant === 'body1' || typographyVariant === undefined) && {
        ...theme.typography.body1,
    }),
    ...(typographyVariant === 'body2' && {
        ...theme.typography.body2,
        padding: '0',
    }),
    '&.MuiListItem-root': {
        display: liststyle ? 'list-item' : 'flex',
        listStyle: liststyle ?? 'none',
    },
    '&.Mui-selected': {
        '&::before': {
            content: '""',
            height: '100%',
            width: '1px',
            backgroundColor: theme.palette.primary.lighter,
            position: 'absolute',
            left: 0,
        },
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.groupPrimary.zurichAzure,
        '&:hover': { backgroundColor: theme.palette.groupPrimary.zurichAzure },
    },
    '&:hover, &:focus': {
        backgroundColor: theme.palette.groupPrimary.zurichAzure,
    },
    '&:active .MuiTouchRipple-root': {
        color: theme.palette.primary.dark,
    },
}));
